'use client';

import Map from '@@components/page/home/Map';
import clx from '@@components/page/home/clx';
import { useTranslations } from 'next-intl';
// import { Suspense } from 'react';

/**
 * Component: ContactSection
 */
const ContactSection = () => {
  const t = useTranslations();

  return (
    <section className={clx('section')}>
      <h2>{t('headers.contacts')}</h2>

      <table className={clx('contact-list')}>
        <tbody>
          <tr>
            <td>{t('contact.address')}:</td>
            <td>
              <a href="https://goo.gl/maps/tfRWtq32RBfyZV7C7" title="4200, Hajdúszoboszló, József Attila u. 6/B" target="_blank" rel="noopener noreferrer">
                4200, Hajdúszoboszló, József Attila u. 6/B
              </a>
            </td>
          </tr>
          <tr>
            <td>Email:</td>
            <td>
              <a href="mailto:hashtagapartman@gmail.com" title="hashtagapartman@gmail.com">
                hashtagapartman@gmail.com
              </a>
            </td>
          </tr>
          <tr>
            <td>Tel:</td>
            <td>
              <a href="tel:+36305296887" title="+36305296887">
                +36305296887
              </a>
            </td>
          </tr>
        </tbody>
      </table>

      {/* <Suspense fallback={null}> */}
      <Map />
      {/* </Suspense> */}
    </section>
  );
};
export default ContactSection;
